if (!customElements.get("product-recommendations")){
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: "0px 0px 400px 0px" }
      );
      this.observer.observe(this);
    }

    initializeInlineOptions() {
      this.querySelectorAll('.product-card--inline-options [data-inline-card-quick-add]').forEach((card) => {
        if (card.dataset.inlineRecommendationOptionsReady === 'true') return;
        let variants;
        try { variants = JSON.parse(card.dataset.variants || '[]'); } catch (error) { return; }
        const variantInput = card.querySelector('[data-inline-card-variant-id]');
        const submitButton = card.querySelector('[type="submit"]');
        if (!variants.length || !variantInput || !submitButton) return;
        card.dataset.inlineRecommendationOptionsReady = 'true';
        card.dataset.inlineCardQuickAddReady = 'true';
        const groups = Array.from(card.querySelectorAll('[data-inline-card-option]'));
        let selectedOptions = [];
        const matches = (variant, options) => variant.options.every((value, index) => value === options[index]);
        const update = (variant) => {
          selectedOptions = variant.options.slice();
          variantInput.value = variant.id;
          submitButton.disabled = !variant.available;
          window.solasInlinePrices?.update(card, variant);
          groups.forEach((group) => {
            const index = Number(group.dataset.inlineCardOption);
            group.querySelectorAll('[data-inline-card-value]').forEach((button) => {
              const value = button.dataset.inlineCardValue;
              button.disabled = !variants.some((candidate) => candidate.available && candidate.options[index] === value && selectedOptions.slice(0, index).every((selected, previous) => candidate.options[previous] === selected));
              button.setAttribute('aria-pressed', String(selectedOptions[index] === value));
            });
            if (group.querySelector('.inline-card-quick-add__option--color')) {
              let name = group.querySelector('.inline-card-quick-add__color-name');
              if (!name) {
                name = document.createElement('span');
                name.className = 'inline-card-quick-add__color-name';
                group.appendChild(name);
              }
              name.textContent = 'اللون: ' + selectedOptions[index];
            }
          });
          const media = variant.featured_image || variant.featured_media;
          const imageUrl = media && (media.src || (media.preview_image && media.preview_image.src));
          const image = card.closest('.product-card-wrapper')?.querySelector('.card--block-media img.motion-reduce');
          if (imageUrl && image) {
            image.src = imageUrl;
            image.removeAttribute('srcset');
          }
        };
        card.addEventListener('click', (event) => {
          const button = event.target.closest('[data-inline-card-value]');
          if (!button || button.disabled) return;
          const index = Number(button.closest('[data-inline-card-option]').dataset.inlineCardOption);
          const proposed = selectedOptions.slice();
          proposed[index] = button.dataset.inlineCardValue;
          const next = variants.find((variant) => variant.available && matches(variant, proposed)) || variants.find((variant) => variant.available && variant.options[index] === proposed[index] && proposed.slice(0, index).every((value, previous) => variant.options[previous] === value));
          if (next) update(next);
        });
        update(variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants.find((variant) => variant.available) || variants[0]);
      });
    }

    loadRecommendations(productId) {
      fetch(
        `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
      )
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initializeInlineOptions();
          }

          if (this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  
  customElements.define("product-recommendations", ProductRecommendations);
}
